import { renderCopyHover } from 'helpers';
import { Colors } from 'libs/ui/theme';

import { DirectoryRecordItemType } from '../../../types';

export const renderValue = (item: DirectoryRecordItemType, field: any) =>
  renderCopyHover(item, field, {
    color: item.isArchived ? Colors.gray500 : undefined,
  });
